"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = App;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _Actions = require("../actions/Actions");
var _reactRouter = require("react-router");
var _queryString = _interopRequireDefault(require("query-string"));
var _CampaignDetails = _interopRequireDefault(require("./CampaignDetails"));
var _selector = require("../selectors/selector");
var _useProps2 = _interopRequireDefault(require("../hooks/useProps"));
var _functions = require("../helpers/functions");
var _Loading = _interopRequireDefault(require("./blocks/Loading"));
var _DetailsHeader = _interopRequireDefault(require("./DetailsHeader"));
var _ErrorComponent = _interopRequireDefault(require("./blocks/ErrorComponent"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function App() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var location = (0, _reactRouter.useLocation)();
  var campaignDetails = (0, _reactRedux.useSelector)(_selector.getDetails);
  var error = (0, _reactRedux.useSelector)(_selector.getError);
  var loading = (0, _reactRedux.useSelector)(_selector.getLoading);
  var _queryString$parse = _queryString.default.parse(location.search),
    offerId = _queryString$parse.offerId,
    msisdn = _queryString$parse.msisdn;
  var _useProps = (0, _useProps2.default)(),
    instanceId = _useProps.__instanceId;
  (0, _react.useEffect)(function () {
    dispatch((0, _Actions.setInstanceId)(instanceId));
  }, [instanceId]);
  function fetchCampaignDetails() {
    if (msisdn && offerId) dispatch((0, _Actions.getCampaignDetails)({
      offerId: offerId,
      msisdn: msisdn
    }));
  }
  (0, _react.useEffect)(function () {
    if (!loading) fetchCampaignDetails();
  }, [offerId, msisdn]);
  if (error) {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DetailsHeader.default, null), /*#__PURE__*/_react.default.createElement(_ErrorComponent.default, {
      buttonAction: fetchCampaignDetails
    }), ";");
  }
  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_Loading.default, null);
  }
  if (!(0, _functions.isArrayValid)(campaignDetails)) {
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "empty-state"
    });
  }
  return /*#__PURE__*/_react.default.createElement(_CampaignDetails.default, {
    campaignDetails: campaignDetails
  });
}